"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { useEffect, useRef } from "react"; 
import { getDisplayName } from "@/data/labels";
import { getLocaleFromPathname, getLocalePrefix } from "@/utils/getLocaleFromPath";
import { FaChevronRight } from "react-icons/fa";

type TrendingProps = {
  nameSlugList: { label: string; link: string }[];
  secondary: string;
};

export default function HeaderTrendingTopics({ nameSlugList, secondary }: TrendingProps) {
  const pathname = usePathname();
  const locale = getLocaleFromPathname(pathname) || "te-IN";
  const localePrefix = getLocalePrefix(pathname);



  return (
    <div className="block border-b border-gray-200 dark:border-darkBorderColor min-h-14 bg-white dark:bg-darkBgPrimaryColor">
      <div className="container flex flex-col sm:flex-row justify-between gap-2 py-2">
        <div className="flex items-center gap-3 overflow-x-auto no-scrollbar flex-nowrap">
          <div className="flex items-center gap-1 border-r border-gray-200 dark:border-darkBorderColor pr-4">
            {/* <span className="hidden text-sm font-[500] text-primaryColor dark:text-primaryColor uppercase lg:block whitespace-nowrap"> */}
            <span className="text-xl xl:text-xl font-[500] text-primaryColor dark:text-primaryColor uppercase xl:block whitespace-nowrap">
              {secondary ? secondary : getDisplayName("MAGAZINES", locale)}
            </span>
            <FaChevronRight className="text-primaryColor text-sm " />
          </div>

          <div className="flex items-center divide-x divide-gray-200 dark:divide-darkBorderColor gap-4">
            {nameSlugList?.map((topic, index) => {
              const rawLink = topic?.link || "#";
              const isExternal = /^https?:\/\//i.test(rawLink);
              const link = isExternal
                ? rawLink
                : `${localePrefix}/${rawLink.replace(/^\/+/, "")}`.replace(/\/+$/, "");

              return (
                <Link
                  key={index}
                  href={link || "#"}
                  target={isExternal ? "_blank" : undefined}
                  rel={isExternal ? "noopener noreferrer" : undefined}
                  aria-label={`View ${topic?.label}`}
                >
                  <span className="block whitespace-nowrap rounded-full text-sm sm:text-base font-medium py-1 tracking-wide pl-4 text-gray-900 dark:text-white hover:text-primaryColor dark:hover:text-primaryColor">
                    {topic?.label}
                  </span>
                </Link>
              );
            })}
          </div>
        </div>
        <div></div>
      </div>
    </div>
  );
}
